import FileServiceModel   from '@/models/FileServiceModel';
import doc                from '@widesk-core/decorators/doc';
import model              from '@widesk-core/decorators/model';

@model.urnResource('source')
@doc.path('/stonecode_file_sources/{?id}')
export default class SourceModel extends FileServiceModel {
	public declare _tsFilters: {
		'entityUrn': string;
	};

	public declare _tsSorts: {
		'id': string;
		'updatedAt': string;
	};

	public get entityUrn() {
		return this.get('entityUrn');
	}
}